export enum ComparisonOperator {
  GreaterThan = 1,
  GreaterThanOrEqual = 2,
  LessThan = 3,
  LessThanOrEqual = 4,
  Equal = 5
  // NotEqual = 6
}

export enum ComparisonOperatorShort {
  GreaterThan = 1,
  GreaterThanOrEqual = 2,
  LessThan = 3,
  LessThanOrEqual = 4,
  Equal = 5
  // NotEqual = 6
}

(ComparisonOperator as any).__typeName = 'ComparisonOperator';
(ComparisonOperatorShort as any).__typeName = 'ComparisonOperatorShort';